import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import PRMaterialConfig from "./PRMaterialConfig";
import { setActiveDataElement } from "../../../redux/userSlice";

function PRCustomConfiguration() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Production Requirement"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="Production Requirement Custom Configuration"
            />
            <div class="container">
                <PRMaterialConfig />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}
export default PRCustomConfiguration
